<!--
 * @Description: 通知公告详情
 * @Author: 裴孚
 * @Date: 2023-04-11 17:49:57
 * @LastEditors: 裴孚
 * @LastEditTime: 2023-05-22 15:29:00
-->

<template>
  <div class="tan-chuang">
    <el-dialog class="w800 h600" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, true)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-card shadow="never">
        <template #header>
          <div class="card-header">
            <h2>{{ruleForm.bt}}</h2>
            <h4 class="fu-biao-ti">
              <span>发布人：{{ruleForm.fbrxm}}</span>
              <span>发布时间：{{ruleForm.fbsj}}</span>
            </h4>
          </div>
        </template>
        <div class="nei-rong">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.nr"></p>
        </div>
      </el-card>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer-but">
            <el-button @click="closeWindow('openDetail', emits, true)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({})
const emits = defineEmits(['update:openDetail'])

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadData({ url: '/api/v2/bangong/tongzhigonggaojieshouren/' + props.row.id, ruleForm })
    }
  },
  { deep: true, immediate: true }
)
</script>
<style lang="less" scoped>
:deep(.el-card__header) {
  text-align: center;
}
.fu-biao-ti {
  color: #73767a;
  margin-top: 10px;
  span {
    margin: 0 10px;
  }
}
.nei-rong {
  color: #73767a;
  line-height: 30px;
}
</style>
